<template>
	<div class="px-6 p-lg-0">
		<div class="d-flex justify-content-center">
			<div class="col-12 col-md-10 col-lg-7 col-xl-5 col-xxl-4 min-h-lg-screen d-flex flex-column justify-content-center py-16 py-lg-16 px-lg-20 position-relative">
				<slot />
			</div>
		</div>
	</div>
</template>